import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

/**
 * Wrapper de notificaciones. Migrado de angular2-toaster (View Engine, sin
 * soporte Angular 12+) a ngx-toastr. La API pública (success/error/warning/info/
 * wait/getConfig) se mantiene para no tocar los ~60 componentes consumidores.
 * ngx-toastr usa un overlay global (ToastrModule.forRoot en AppModule), por eso
 * ya no hace falta <toaster-container> ni getConfig().
 */
@Injectable({
  providedIn: 'root'
})
export class AppToastService {

  constructor(private toastr: ToastrService) {
  }

  public success(title: string, body?: string): void {
    this.toastr.success(body || '', title);
  }

  public error(title: string, body?: string): void {
    this.toastr.error(body || '', title);
  }

  public warning(title: string, body?: string): void {
    this.toastr.warning(body || '', title);
  }

  public info(title: string, body?: string): void {
    this.toastr.info(body || '', title);
  }

  public wait(title: string, body?: string): void {
    this.toastr.info(body || '', title);
  }

  /** Conservado por compatibilidad; ngx-toastr se configura en AppModule. */
  public getConfig(): any {
    return {};
  }
}
